import { AuthorizedS3Adapter } from '@studyportals/client-internal-platform-aws-authorization';
import { S3 } from "@aws-sdk/client-s3";

// sp-r2d2 v5 builds its client in the `client` getter and never calls createS3(), so AuthorizedS3Adapter's
// region and Cognito credentials were ignored ("Region is missing").
// Remove once fixed upstream within client-internal-platform-aws-authorization.
export class RegionAwareAuthorizedS3Adapter extends AuthorizedS3Adapter {
	protected override get client(): S3 {
		// Not cached, so every call picks up the current (refreshed) credentials, as createS3() did before.
		return this.createS3();
	}
}
